export default __webpack_public_path__ + "static/media/invite.6d548953.svg";